<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       width="24"
       height="24"
       viewBox="0 0 24 24"
       fill="none"
       stroke="#0E0E22"
       stroke-width="2"
       stroke-linecap="round"
       stroke-linejoin="round"
  >
    <circle cx="12"
            cy="12"
            r="10"
            stroke="#0E0E22"
    />
    <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"
          stroke="#0E0E22"
    />
    <path d="M2 12h20"
          stroke="#0E0E22"
    />
  </svg>
</template>